import React from 'react';
import Component from '@/Component';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { yyyymmdd } from '@/utils/date'
import DatePicker from '@/components/common/DatePicker';
import TimeSelector from '@/components/common/TimeSelector';
import OutsideTime from '@/components/outside/OutsideTime';

class OutsideModal extends Component {

  closeModal() {
    this.props._closeOutsideModal();
  }

  onChangeStartDate(d) {
    this.props._updateOutsideInputValue('startDate', yyyymmdd(d))
  }

  onChangeEndDate(d) {
    this.props._updateOutsideInputValue('endDate', yyyymmdd(d))
  }

  onChangeInputValue(e) {
    this.props._updateOutsideInputValue(e.target.name, e.target.value)
  }

  onClickSave() {
    this.props._saveOutside();
  }

  onClickRetrieve() {
    this.props._getOutside();
  }

  render() {
    const {
      isOpen,
      startDate,
      endDate,
      startHour,
      startMinute,
      endHour,
      endMinute,
      outsideList,
      _removeOutside
    } = this.props;

    return (
      <Modal isOpen={isOpen} size="lg" toggle={this.closeModal} backdrop="static" modalClassName="info">
        <ModalHeader toggle={this.closeModal}>외근/교육</ModalHeader>
        <ModalBody>
          <div className="main">
            <div className="row">
              <div className="col-md-3">
                <label className="text-danger" htmlFor="date">시작날짜 (*)</label>
                <DatePicker date={startDate} onDayChange={this.onChangeStartDate} />
              </div>
              <div className="col-md-3">
                <label className="text-danger" htmlFor="date">종료날짜 (*)</label>
                <DatePicker date={endDate} onDayChange={this.onChangeEndDate} />
              </div>
              <div className="col-md-3">
                <label className="text-danger" htmlFor="startTime">시작시간 (*)</label>
                <TimeSelector hourName="startHour" minuteName="startMinute" hour={startHour} minute={startMinute} 
                  onChangeHour={this.onChangeInputValue} onChangeMinute={this.onChangeInputValue} />
              </div>
              <div className="col-md-3">
                <label className="text-danger" htmlFor="startTime">종료시간 (*)</label>
                <TimeSelector hourName="endHour" minuteName="endMinute" hour={endHour} minute={endMinute}
                  onChangeHour={this.onChangeInputValue} onChangeMinute={this.onChangeInputValue} />
              </div>
            </div>
            <hr />
            <button className="btn btn-primary btn-block" type="button" onClick={this.onClickSave}>저장</button>
            <hr />
            <div>
              <OutsideTime outsideList={outsideList} _removeOutside={_removeOutside} />
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default OutsideModal;



// WEBPACK FOOTER //
// ./src/components/outside/OutsideModal.js